import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-btn-route',
  standalone: true,
  templateUrl: './btn-route.component.html',
  styleUrls: ['./btn-route.component.css'],
})
export class BtnRouteComponent {
  route: ActivatedRoute = inject(ActivatedRoute);
  router: Router = inject(Router);
  @Input() routeTo: string = '..';
  @Input() queryParams: any;
  @Input() returnParams: any;
  @Input() btnText: string = 'Back';
  @Input() disabled: boolean = false;
  @Input() textStyle: string = 'font-semibold';
  @Input() padding: string = 'px-4 py-2';
  @Input() shadow: boolean = true;
  @Input() icon: string | undefined;
  @Input() colors: string = 'bg-secondary-500 hover:bg-secondary-400';
  @Input() textColor: string = 'text-white';
  @Input() replaceUrl: boolean = false;

  constructor() {}

  navigate() {
    const extras: any = {
      replaceUrl: this.replaceUrl,
    };
    if (!this.routeTo.startsWith('/')) {
      extras.relativeTo = this.route;
    }
    if (this.queryParams) {
      extras.queryParams = this.queryParams;
    }
    this.router.navigate([this.routeTo], extras);
  }
}
